<template>
  <div class="bbe-radio-form">
    <label class="bbe-radio-form-item"
           @click.stop
           :class="{
             'bbe-radio-form-item_disabled': disabled
           }"
           v-for="option in options"
           :key="option.id">
      <input class="bbe-radio-form-item__input"
             type="radio"
             :disabled="disabled"
             :value="option.id"
             :checked="option.checked"
             v-model="picked">
      <span class="bbe-radio-form-item__checkmark"/>
      <span class="bbe-radio-form-item__title">{{option.title}}</span>
    </label>
  </div>
</template>

<script>
import {find} from 'lodash'

export default {
  name: 'EmailRadioInput',
  props: ['options', 'disabled'],
  data () {
    return {
      picked: false
    }
  },
  methods: {
    setDefaultValue () {
      const value = find(this.options, {checked: true}) || {}
      this.picked = value.id
    }
  },
  watch: {
    picked () {
      this.$emit('checked', this.picked)
    },
    options () {
      this.setDefaultValue()
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-radio-form {
  display: grid;
  width: 100%;
  grid-gap: 12px;
  align-items: center;
  user-select: none;

  &-item {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      color: $color-accent;
    }

    &__input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

      &:checked + .bbe-radio-form-item__checkmark {
        &:after {
          opacity: 1;
        }
      }
    }

    &__checkmark {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 12px;
      height: 12px;
      border: 1px solid $color-accent;
      box-sizing: border-box;
      border-radius: 50%;
      margin-right: 5px;

      &:after {
        content: '';
        position: absolute;
        background-color: $color-accent;
        width: 6px;
        height: 6px;
        opacity: 0;
        border-radius: 50%;
        transition: 0.3s;
      }
    }

    &__title {
      font-size: 13px;
      line-height: 16px;
    }

    &_disabled {
      cursor: default;
      pointer-events: none;
    }

    &_disabled &__title {
      color: $color-silver-chalice
    }

    &_disabled &__checkmark {
      border-color: $color-silver-chalice;

      &:after {
        background-color: $color-silver-chalice;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/FormsElements/EmailRadioInput.vue